import { render, staticRenderFns } from "./opcr-view.vue?vue&type=template&id=21490f3d&"
import script from "./opcr-view.vue?vue&type=script&lang=js&"
export * from "./opcr-view.vue?vue&type=script&lang=js&"
import style0 from "./opcr-view.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports